export interface ExpensePolicyClass {
    AccountExpensePolicyId: string
    AccountId: number
    ExpensePolicyName: string
    ExpensePolicyDescription: string
    AccountAbsenceTypeGuidId: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn:  Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDeleted: boolean
    ExpenseAmountLimit: number
    ReceiptRequiredLimit: number
    IsDescriptionRequired: boolean
    LockAllPreviousExpenseEntries: boolean
    LockAllPreviousMonthsExpenseEntries: boolean
    isSelected: number
}

export const expensePolicyInitialsForAdd = {
    ExpensePolicyName: "",
    ExpensePolicyDescription: "",
    IsDisabled: false
}

export const expensePolicyInitialsForUpdate = {
    AccountExpensePolicyId: "",
    ExpensePolicyName: "",
    ExpensePolicyDescription: "",
    IsDisabled: false
}